<template>
  <div class="box">
    <img class="img" src="/assets/image/icon.png" />
  </div>
</template>

<script>

export default {
  name: "LaunchIcon",
}
</script>

<style scoped>
  .box{
    text-align: center;
    margin-top: 6vh;
  }
  .img{
    height: 90%;
    margin: 0 auto;
  }
</style>